/* eslint-disable */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import welcomeBg from "../assets/parent-welcome-bg-premium.png";
import logoWhite from "../assets/presentplus-logo-white.png";
import "../styles/parent/ParentEntry.css";
import secureIcon from "../assets/welcome-icons/pp-secure.svg";
import realtimeIcon from "../assets/welcome-icons/pp-realtime.svg";
import connectedIcon from "../assets/welcome-icons/pp-connected.svg";


export default function ParentWelcome() {
  const navigate = useNavigate();

  useEffect(() => {
    const seenSplash = sessionStorage.getItem("pp_parent_splash_seen");

    if (!seenSplash) {
      navigate("/parent-splash", { replace: true });
      return;
    }

    sessionStorage.removeItem("pp_parent_splash_seen");
  }, [navigate]);

  return (
    <div className="pp-entry-screen-fixed pp-entry-welcome-premium">
      <img src={welcomeBg} alt="" className="pp-entry-bg-image pp-entry-bg-welcome" />
      <div className="pp-entry-bg-veil" />
      <div className="pp-entry-welcome-grid" />
      <div className="pp-entry-welcome-orb pp-entry-welcome-orb-a" />
      <div className="pp-entry-welcome-orb pp-entry-welcome-orb-b" />

      <main className="pp-entry-content pp-entry-content-welcome">
        <section className="pp-entry-welcome-hero" aria-label="PresentPlus welcome">
          <img src={logoWhite} alt="PresentPlus" className="pp-entry-real-logo pp-entry-real-logo-welcome" />

          <div className="pp-entry-copy-fixed">
            <h1>Welcome to PresentPlus</h1>
            <p>Track your child's attendance with ease.</p>
          </div>
        </section>

<section className="pp-entry-feature-row" aria-label="PresentPlus benefits">
  <article className="pp-entry-feature-card">
    <div className="pp-entry-feature-icon">
      <img src={secureIcon} alt="" />
    </div>
    <strong>Secure</strong>
    <span>Your data is always protected</span>
  </article>

  <article className="pp-entry-feature-card">
    <div className="pp-entry-feature-icon">
      <img src={realtimeIcon} alt="" />
    </div>
    <strong>Real-time</strong>
    <span>Get instant updates and notifications</span>
  </article>

  <article className="pp-entry-feature-card">
    <div className="pp-entry-feature-icon">
      <img src={connectedIcon} alt="" />
    </div>
    <strong>Connected</strong>
    <span>Stay connected with your child&apos;s school</span>
  </article>
</section>

        <button type="button" className="pp-entry-fixed-btn pp-entry-premium-cta" onClick={() => navigate("/parent-login")}>
          <span>Get Started</span>
          <span className="pp-entry-cta-arrow" aria-hidden="true">→</span>
        </button>
      </main>
    </div>
  );
}
